import React from 'react'
import T from 'prop-types'
import { Typography } from '@mui/material'

export default function DeltaTableCell({ value, ...others }) {
  return (
    <Typography
      component="span"
      variant="body2"
      color={value === 0 ? 'primary' : value > 0 ? 'error' : undefined}
      {...others}
    >
      {value && `${value > 0 ? '+' : ''}${value}`}
    </Typography>
  )
}

DeltaTableCell.propTypes = {
  value: T.node,
}
